import React from 'react';
import { useData } from '../../../contexts';
import { DataGrid } from '@mui/x-data-grid';
import { ScatterChartOneDimensionalSmall } from '../../ScatterChartOneDimensional/ScatterChartOneDimensionalSmall';

import { Tooltip, TooltipTrigger, TooltipContent } from '../../Tooltip/Tooltip';

export const VogelvluchtRegisterTable = (props: any) => {
  const { data } = props;
  const { tableWidth, colors, selectedGemeente, selectedBenchmarks } =
    useData();

  const scatterShartOneDimensionalProps = [
    {
      id: 0,
      fieldName: selectedGemeente.label,
      type: 'main',
      size: 1000,
    },
  ];

  selectedBenchmarks.forEach((d: any, i: any) => {
    i < 1 &&
      scatterShartOneDimensionalProps.push({
        id: i + 1,
        fieldName: d.label,
        type: 'benchmark',
        size: 300,
      });
  });

  const cols: any = [
    {
      field: 'label',
      headerName: 'Indicator',
      width: 360,
      align: 'right',
      renderCell: (params: any) => {
        const out = params.row.detail
          ? params.row.detail.ratio === '%'
            ? '(procent - ' + params.row.jaar + ')'
            : params.row.detail.ratio === null ||
              params.row.detail.ratio === undefined ||
              params.row.detail.ratio === ''
            ? `(${params.row.detail.eenheid} - ${params.row.jaar})`
            : `(${params.row.detail.eenheid} ${params.row.detail.ratio} - ${params.row.jaar})`
          : '-';
        return (
          <Tooltip>
            <TooltipTrigger>
              <div style={{ textAlign: 'right' }}>
                <p style={{ marginBottom: '2px' }} title={params.row.label}>
                  {params.row.label}{' '}
                </p>
                <p style={{ color: '#888' }}>{out}</p>
              </div>
            </TooltipTrigger>
            <TooltipContent className="Tooltip">
              <p>
                {params.row.detail
                  ? params.row.definitie
                  : 'Definitie ontbreekt'}
              </p>
            </TooltipContent>
          </Tooltip>
        );
      },
    },
    {
      field: 'visual',
      headerName: 'Visual',
      renderCell: (row: any) => {
        return renderDotChart(row, 'id', scatterShartOneDimensionalProps);
      },
      flex: 1,
    },
  ];

  const renderDotChart = (
    props: any,
    idField: any,
    scatterShartOneDimensionalProps: any[],
  ) => {
    const { row } = props;
    const arr = [row];
    return (
      <ScatterChartOneDimensionalSmall
        data={arr}
        idField={idField}
        visualProps={scatterShartOneDimensionalProps}
        density={getDensity()}
      ></ScatterChartOneDimensionalSmall>
    );
  };

  const getDensity = () => {
    const density =
      data !== undefined && data.length > 9 ? 'comfortable' : 'comfortable';
    return density;
  };

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <DataGrid
        rows={data}
        columns={cols}
        hideFooter={true}
        rowHeight={100}
        // density={getDensity()}

        slots={{
          columnHeaders: () => null,
        }}
        disableColumnMenu
        disableRowSelectionOnClick
        sx={{
          boxShadow: 0,
          border: 0,
          backgroundColor: '#FFF',
          '& .MuiDataGrid-columnHeader:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-cell': {
            cursor: 'pointer',
            border: 'none',
            outline: 'none',
            '&:focus': {
              outline: 'none',
            },
          },
          '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
            width: '0.8em',
            height: '0.8em',
          },
          '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track': {
            background: '#f1f1f1',
          },
          '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
            backgroundColor: '#888',
          },
          '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover': {
            background: '#555',
          },
          '& .MuiDataGrid-virtualScroller': {
            // scrollbarColor: 'red blue',
            scrollbarWidth: 'thin',
          },
        }}
      />
    </div>
  );
};
